// ============================================================
// Branch detection (#75, concept): illustrative findings of one shift
// on the stone conveyor. Seeded, so screenshots stay stable. A real
// version needs a camera over the belt and a trained image model.
// ============================================================

import { rng } from './statsData';

const SHIFT_START = 6; // morning shift 6–14
// Outcome per finding: ejected by the flap, waiting for the operator, or a false alarm.
const OUTCOMES = ['ejected', 'ejected', 'ejected', 'ejected', 'review', 'false'];

function buildFindings() {
  const r = rng(7575);
  return Array.from({ length: 14 }, (_, i) => {
    const minute = Math.floor(r() * 8 * 60);
    const outcome = OUTCOMES[Math.floor(r() * OUTCOMES.length)];
    return {
      id: `F-${String(i + 1).padStart(2, '0')}`,
      time: `${String(SHIFT_START + Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`,
      lengthCm: Math.round(8 + r() * 40),
      confidence: outcome === 'false' ? Math.round(55 + r() * 15) : Math.round(82 + r() * 17),
      outcome,
      // Position of the box in the frame (0–100 %), for the drawn sample frame.
      box: { x: Math.round(10 + r() * 60), y: Math.round(25 + r() * 40), w: Math.round(12 + r() * 18), h: Math.round(6 + r() * 8), angle: Math.round(-40 + r() * 80) },
    };
  }).sort((a, b) => a.time.localeCompare(b.time));
}

export const shiftFindings = buildFindings();

export const shiftSummary = {
  total: shiftFindings.length,
  ejected: shiftFindings.filter(f => f.outcome === 'ejected').length,
  review: shiftFindings.filter(f => f.outcome === 'review').length,
  falseAlarms: shiftFindings.filter(f => f.outcome === 'false').length,
  perHour: Array.from({ length: 8 }, (_, i) => ({
    hour: `${SHIFT_START + i}`,
    count: shiftFindings.filter(f => Number(f.time.slice(0, 2)) === SHIFT_START + i).length,
  })),
};
